export const ROOT_ID = 'pp-widget-root';

export enum RootHtmlAttributeKey {
  DataIsDemoAccount = 'data-is-demo-account',
  DataIsDemoExperience = 'data-pp-is-demo-experience',
}
